import React from 'react';
import EstadoCuentaListado from './EstadoCuentaListado.jsx';

// Réplica de `IbuFront/.../CXP/EstadoCuentaCXP/EstadoCuentaCXP.jsx` (ver EstadoCuentaListado.jsx).
// `GET /reportes/estado-cuenta/proveedor/:id` trae {fecha, movimiento, concepto, cargo,
// abono, numero} SIN comisión; el saldo corrido se calcula en el navegador.
const CFG = {
  permiso: 'estado-cuenta:proveedores',
  route: 'proveedores',
  nombreKey: 'name',
  titulo: 'Cuentas Por Pagar',
  encabezadoNombre: 'Nombre',
  encabezadoAcciones: 'ESTADO CUENTA',
  entidad: 'Proveedor',
  conComision: false,
  prefijoAbonosPeriodo: '-',
  kardexPath: (id) => `/reportes/estado-cuenta/proveedor/${id}`,
  relacionadoPath: (id) => `/reportes/estado-cuenta/proveedor/${id}/relacionado`,
  tituloPdf: 'Estado de Cuenta Proveedores',
  archivoPdf: 'EstadosDeCuentaProv',
  archivoExcel: 'EstadoCuentaProv',
  archivoModal: 'EdoCtaProveedor',
  hojaModal: 'EstadoCuentaProv',
};

export default function EstadoCuentaProveedorPage() {
  return <EstadoCuentaListado cfg={CFG} />;
}
